module.exports = __webpack_public_path__ + "static/media/26.354de9d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/26.png
// module id = 1067
// module chunks = 0